import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

import { nextInNeedsYouQueue } from '../utils/batches-table';

/**
 * "Next waiting batch ›" on a batch opened from the Batches table's Needs you view: walks the
 * queue that view saved for the session, so triage is one batch after another without the list.
 * Renders nothing when this batch wasn't opened from that queue or is its last.
 */
export function NextWaitingBatchLink({ runId }: { runId: string }) {
  const { t } = useTranslation('catalog-enrichment-runs');
  const next = nextInNeedsYouQueue(runId);
  if (!next) return null;
  return (
    <Button
      asChild
      variant="outline"
      className="cursor-pointer"
      data-testid="catalog-enrichment-run-next-waiting-button"
    >
      <Link to="/catalog-enrichment/runs/$runId/gate" params={{ runId: next }}>
        {t('batchesTable.nextWaiting')}
        <ChevronRight aria-hidden="true" />
      </Link>
    </Button>
  );
}
